import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Paper } from '../../../../catalyst/core';
import { Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import FormCapture from './FormCapture';
import { useDispatch, useSelector } from 'react-redux';
import { loadQlikApps } from '../../../../redux/actions/qlikActions';
import { qlikAppsSelector } from '../../../../redux/qlik/selectors';
import { ToastsStore } from 'react-toasts';
import api from 'api';

const FormHeader = ({ formEndpoint, initialValues, saveAction, formId }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [reloading, setReloading] = useState(false);

    const reload = () => {
        setReloading(true);
        api.forms
            .reload(formId)
            .then(() => {
                setReloading(false);
                ToastsStore.success('App Reloaded Successfully');
            })
            .catch((err) => {
                console.error(err);
                setReloading(false);
                ToastsStore.error('Apps failed to reload');
            });
    };

    useEffect(() => {
        dispatch(loadQlikApps()).catch((err) => {
            console.error('apps failed to load', err);
            ToastsStore.error('Apps failed to load, please reconnect to Qlik');
        });
    }, []);

    return (
        <Paper>
            <Grid
                container
                direction="row"
                justifyContent={'space-between'}
                xs={12}
                style={{ marginBottom: '20px' }}
            >
                <Grid item>
                    <Typography variant="h3" noWrap>
                        Form Builder
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid container spacing={1}>
                        <Grid item>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => reload()}
                                disabled={!formId || reloading}
                            >
                                Reload App
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => history.goBack()}
                            >
                                Back
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FormCapture
                formEndpoint={formEndpoint}
                initialValues={initialValues}
                saveAction={saveAction}
            />
        </Paper>
    );
};

export default FormHeader;

FormHeader.propTypes = {
    initialValues: PropTypes.object.isRequired,
    saveAction: PropTypes.func.isRequired,
    reload: PropTypes.func,
    formId: PropTypes.string,
};

FormHeader.defaultProps = {
    reload: () => {},
    formId: null,
};
